import { Component, ChangeDetectionStrategy } from "@angular/core";
import { IonApp, IonRouterOutlet } from "@ionic/angular";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
  template: "<ion-app><ion-router-outlet /></ion-app>",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthShell {}
